import AssetAllocation from './AssetAllocation';
import Performance from './Performance';
import TotalOngoingCharge from './TotalOngoingCharge';
import Risk from './Risk';

export default { AssetAllocation, Performance, TotalOngoingCharge, Risk };
